import React from 'react';
import {
    Link
} from 'react-router-dom'
import './Entry.css';

export interface RawEntryConfig{
  text: string,
  link: string,
}


function RawEntry(conf: RawEntryConfig) {
  return (
    <div className='menu-item' key={conf.link}>
        <Link to={conf.link}>
            <p>
                {conf.text}
            </p>
        </Link>
    </div>
  );
}

export default RawEntry;